module.exports = "/virtual-football-league/img/amblems/left/logos/Inter.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Inter.png
// module id = 2099
// module chunks = 4